import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { message, Layout, Menu } from 'antd';
import store from 'store';
import { setParam, getParam } from 'ruigu-utils';
import {
  getArray,
  qtPagePvFun,
  getMenuInfoByUrl,
  getMenuInfoById,
  checkIsLaunchpad,
  checkPasswordExpiration,
  hrefUserHomeInfo,
} from '@/utils/util';
import iconList from '@/utils/iconList';

// components
import IndexHead from '@/components/IndexHeader/IndexHead';
import IndexIframe from '@/components/IndexIframe/IndexIframe';
import IndexTabsNavigation from '@/components/IndexTabsNavigation/IndexTabsNavigation';
// api
import { menu, menusV2, lambdaPassportH5 } from '@/api/index';
import { checkToken } from '@/api/login';


// stylus
import './index.styl';

const { Content, Sider } = Layout;

let menuBack = [];

// 递归过滤没有合法path或children节点数据
function filterRouterItem(arr, isNotLoadIcon) {
  return arr
    .filter(
      (ite) =>
        (ite.path && ite.path.includes('//')) ||
        (ite.children && ite.children.length > 0) ||
        (ite.treeList && ite.treeList.length > 0),
    )
    .map((element) => {
      if (element.treeList && element.treeList.length > 0) {
        element.treeList = filterRouterItem(element.treeList);
        return element;
      }
      const item = {
        id: String(element.id),
        title: element.title,
        key: element.id,
        label: element.title,
        path: element.path,
        icon: isNotLoadIcon ? (
          ''
        ) : (
          <span className="menu-iconfont">
            <i className="iconfont icon-Application" />
          </span>
        ),
      };
      if (element.children && element.children.length > 0) {
        item.children = filterRouterItem(element.children, true).filter(
          (ite) =>
            (ite.path && ite.path.includes('//')) ||
            (ite.children && ite.children.length > 0) ||
            (ite.treeList && ite.treeList.length > 0),
        );
      } else {
        delete item.children;
      }
      return item;
    });
}

// 递归获取第一个地址
function pathFirstRouter(arr, keys = []) {
  for (const element of arr) {
    const newKeys = [String(element.id), ...keys];
    if (element.children && element.children.length > 0) {
      return pathFirstRouter(element.children, newKeys);
    } else {
      return {
        ...element,
        openKeys: newKeys,
      };
    }
  }
}

// 拼接上报地址（iframe 不拼 token，子应用经 postMessage 回投获取）
function returnPath(path, id) {
  const iframeSplit = (path || '').split('?');
  return `${iframeSplit[0]}?${
    iframeSplit[1] ? iframeSplit[1] + '&' : ''
  }id=${id}`;
}

// 判断地址中是否已包含指定的 id 参数
function hasIdParam(path = '', id = '') {
  const query = path.split('?')[1] || '';
  return query.split('&').some((item) => item === `id=${id}`);
}

// 过滤url前缀、后缀
function returnBaseUrl(url = '') {
  const newUrl = url
    .replace(/http:\/\/|https:\/\/|\/\//, '')
    .replace(/test.|dev.|uat./, '')
    .split('&_t=')[0];
  return newUrl;
}

class Index extends Component {
  state = {
    companyLogo: '',
    companyName: '',
    menu: [],
    systemList: [],
    allModule: [],
    openModule: [],
    openModuleId: -1,
    removeModuleId: -1,
    headerMenu: [],
    activeIndex: 0,
    // homeList: [],
    tenantMenuList: [],
    opera: '',
    isInitStatus: true,
    openKeys: [],
    selectedKeys: [],
    routerMenu: [],
    collapsed: false,
  };

  componentDidMount() {
    this.init();
  }

  // 初始化方法
  async init () {
    try {
      const token = store.get('token');
      if (typeof token === 'undefined' || token === '') {
        this.props.history.push('/login');
        return;
      }

      // 校正首页-防止用户私自切换首页路由
      const userInfo = store.get('userInfo') || (await checkToken(token)) || {};
      if (!userInfo.bizOrgType) {
        store.remove('token');
        localStorage.clear();
        this.props.history.push('/login');
        return;
      }
      store.set('userInfo', userInfo);

      // 读取缓存，加载租户logo和名称、标签模块
      this.readCacheInfo();

      // 采购工作台、业务工作台
      if (getParam('board_group') === '2') {
        this.getMenuTaskBoard('采购工作台左侧菜单树', '采购工作台');
      } else {
        // 校验首页，防止手动修改url
        if ([1].includes(userInfo.bizOrgType) && checkIsLaunchpad()) {
          this.props.history.push('/');
          return;
        }

        // 获取全部菜单 - 业务租户
        if (checkIsLaunchpad()) {
          this.getMenuV2();
        } else {
          this.getMenuV1();
        }

        // 首页查询密码有效期进行提醒
        // checkPasswordExpiration()
        //   .then(() => this.onClickModule(hrefUserHomeInfo('4')))
        //   .catch(() => {});
      }

      // 设置首页内容
      // this.setHomeContent();

      // 设置监听-父子通信
      window.addEventListener('message', ({ data }) => {
        // 获取postMessage数据
        const {
          url,
          params = {},
          title = '',
          systemId = '',
          id,
          backPath,
          menuUrl, // 针对子应用内子页面无法匹配到菜单高亮问题
        } = data;
        if (url === undefined) return;
        // 获取url参数
        const paramsList = [];
        for (let item in params) {
          paramsList.push(`${item}=${params[item] || ''}`);
        }
        // 设置请求参数
        const path = `${url}${url.includes('?') ? '&' : '?'}${paramsList.join(
          '&',
        )}`;

        // 统一处理打开页面
        this.onClickModule({
          id: id || '',
          title,
          path,
          backPath,
          systemId,
          menuUrl,
        });
      });
    } catch (error) {
      console.error('init error', error);
    }
  }

  // 切换和回写菜单
  handleNavMenu(treeList) {
    const pathInfo = pathFirstRouter(treeList);
    if (!pathInfo) return message.warning('菜单信息错误，请联系管理员');
    const { path, openKeys, id } = pathInfo || {};
    const setInfo = {
      routerMenu: treeList || [],
      openKeys,
      selectedKeys: String(id),
    };
    this.setState(setInfo);
    if (!path) return message.warning('菜单信息错误，请联系管理员');
    // 统一处理打开页面并且上报
    this.onClickModule(pathInfo);
  }

  onMenuClick = (e) => {
    const {
      item: {
        props: { path, children },
      },
      keyPath: openKeys,
      key,
    } = e;
    if (!path) return message.warning('菜单信息错误，请联系管理员');
    if (path.startsWith('https://doc.weixin.qq.com')) {
      return window.open(path);
    }
    const newArr = children[0];
    const { children: title } = newArr[newArr.length - 1].props || {};
    const setInfo = {
      openKeys,
      selectedKeys: [key],
      navIndex: getParam('navIndex') || '0',
    };
    this.setState(setInfo);
    store.set('openModuleOpenInfo', setInfo);

    // 统一处理打开页面并且上报
    this.onClickModule({
      id: `${key}`,
      title: title,
      path,
      backPath: path,
      systemId: '',
    });
  };

  onMenuOpen = (openKeys) => {
    this.setState({
      openKeys,
    });
  };

  /**
   * 获取全部菜单 - 业务租户
   * @returns {Promise<void>}
   */
  async getMenuTaskBoard(roleCode, scopeName) {
    try {
      const data = await lambdaPassportH5({
        route: 'taskBoard/taskNemuTree',
        roleCode,
      });
      // 递归过滤没有合法path或children节点数据
      const menuList = filterRouterItem(data);
      const tenantMenuList = [
        {
          scopeName,
          treeList: menuList,
        },
      ];
      this.setState(
        {
          tenantMenuList,
        },
        () => {
          this.initCheckTabItem(tenantMenuList);
        },
      );
    } catch (e) {
      message.warning(e.message || '');
    }
  }

  // 获取全部菜单 - 业务租户（旧版）
  async getMenuV1() {
    try {
      const data = await menu();
      const newArr = Array.isArray(data) ? data : [];
      // 递归过滤没有合法path或children节点数据
      const menuList = filterRouterItem(newArr);
      const tenantMenuList = [
        {
          scopeName: '目录',
          treeList: menuList,
        },
      ];
      this.setState(
        {
          tenantMenuList,
        },
        () => {
          this.initCheckTabItem(tenantMenuList);
        },
      );




      // const menuListName = [];
      // this.setState(
      //   {
      //     headerMenu: menuListName,
      //     routerMenu: menuList,
      //     // tenantMenuList: menuList,
      //     // activeIndex: getParam('navIndex') || 0,
      //   },
      //   () => {
      //     // this.initCheckTabItem(menuList);
      //   },
      // );
    } catch (e) {
      message.warning(e.message || '');
    }
  }

  /**
   * 获取全部菜单 - 业务租户
   * @returns {Promise<void>}
   */
  async getMenuV2() {
    try {
      const data = await menusV2();
      const res = Array.isArray(data) ? data : [];
      const newArr = res.filter(
        (item) => getArray(item.treeList).length > 0 && item.scopeName,
      );
      // 递归过滤没有合法path或children节点数据
      const menuList = filterRouterItem(newArr);
      const menuListName = menuList.map((item) => item.scopeName);
      this.setState(
        {
          headerMenu: menuListName,
          tenantMenuList: menuList,
          activeIndex: getParam('navIndex') || 0,
        },
        () => {
          this.initCheckTabItem(menuList);
        },
      );
    } catch (e) {
      message.warning(e.message || '');
    }
  }

  // 初始化锁定
  initCheckTabItem(menuList) {
    // 初始化锁定
    let navIndex = getParam('navIndex') || '0';
    const openModuleOpenInfo = store.get('openModuleOpenInfo') || {};
    if (!menuList[navIndex] || !menuList[navIndex].treeList) {
      if (!menuList[navIndex] && menuList[0] && menuList[0].treeList) {
        navIndex = 0;
        setParam('navIndex', 0);
      } else {
        return message.warning('菜单信息异常，请联系管理员');
      }
    }
    const treeList = menuList[navIndex].treeList;
    if (openModuleOpenInfo && navIndex == openModuleOpenInfo.navIndex) {
      this.setState({
        routerMenu: treeList,
      });
      // 统一处理打开页面并且上报
      this.onClickModule({
        ...openModuleOpenInfo,
        id: `${openModuleOpenInfo.id || openModuleOpenInfo.key}`,
      });
    } else {
      this.handleNavMenu(treeList);
    }
  }

  /**
   * 设置菜单
   * @param menu
   * @returns {[]}
   */
  setMenuList(menu) {
    const menuList = [];

    for (let {
      id,
      title,
      children,
      path = '',
      menuDescription = '',
      icon = '',
      type,
    } of menu) {
      const otherModule = []; // 系统模块

      const obj = {
        id,
        title,
        path,
        backPath: path,
        menuDescription,
        icon,
        type,
        children: getArray(children).map((item) => {
          this.setMenuList(item.children).map((childItem) => {
            return item.type !== 1 ? otherModule.push(childItem) : '';
          });
          return {
            id: item.id,
            title: item.title,
            path: item.path || '',
            backPath: item.path || '',
            icon: item.icon,
            menuDescription: item.menuDescription,
            type: item.type,
            children: item.type !== 1 ? [] : item.children,
          };
        }),
      };

      obj.children =
        otherModule.length !== 0
          ? [...obj.children, ...otherModule]
          : obj.children;

      menuList.push(obj);
    }

    return menuList;
  }

  /**
   * 设置系统模块权限
   * @param menu
   * @returns {*}
   */
  setModulePower(menu) {
    for (let item of menu) {
      if (
        item.children.length > 0 &&
        this.checkNeedPowerPath(item.children[0].path)
      ) {
        const powerModuleList = item.children.map((item) => {
          const keyword = item.path.match(/#\/([a-zA-Z0-9-]{1,})/gi);

          if (!Array.isArray(keyword)) return '';

          const keywordArr = keyword.join().split('#/');
          if (keywordArr.length === 2) {
            return keywordArr[1];
          } else {
            return '';
          }
        });

        const powerModuleString = `menuList=${encodeURIComponent(
          powerModuleList.join('|'),
        )}`;
        for (let childItem of item.children) {
          childItem.path = childItem.path.includes('?')
            ? `${childItem.path}&${powerModuleString}`
            : `${childItem.path}?${powerModuleString}`;
          childItem.backPath = childItem.backPath.includes('?')
            ? `${childItem.backPath}&${powerModuleString}`
            : `${childItem.backPath}?${powerModuleString}`;
        }
      }
    }

    return menu;
  }

  /**
   * 获取所有系统、模块的名称、id
   * @param menu
   * @returns {*}
   */
  setSystemList(menu) {
    const systemList = menu.map(({ id, title }) => {
      return {
        title,
        id,
        active: false, // 是否被选择
        iconClassName:
          (
            iconList.find(({ keyword }) => {
              return keyword.find((item) => title.includes(item));
            }) || {}
          ).iconClassName || '', // icon
      };
    });

    systemList.unshift({
      title: '全部',
      id: '',
      active: true, // 是否被选择
      iconClassName: 'icon-quanbu-33x', // icon
    });

    return systemList;
  }

  /**
   * 获取所有模块
   * @param systemList
   * @returns {*}
   */
  setAllModule(systemList) {
    return this.flatten(systemList.map(({ children }) => children));
  }

  flatten(input) {
    const stack = [...input];
    const res = [];
    while (stack.length) {
      // pop value from stack
      const next = stack.pop();
      if (Array.isArray(next)) {
        // push back array items, won't modify the original input
        stack.push(...next);
      } else {
        res.push(next);
      }
    }
    //reverse to restore input order
    return res.reverse();
  }

  /**
   * 点击导航条
   * @param index 导航索引
   */
  onClickNavigation(index) {
    this.setState({
      systemList: this.state.systemList.map((item, listIndex) => {
        item.active = index === listIndex;

        if (index === listIndex) {
          this.setClickMenu(item.id);
          item.active = true;
        } else {
          item.active = false;
        }
        return item;
      }),
    });
  }

  /**
   * 设置点击的系统
   * @param id
   */
  setClickMenu(id) {
    this.setState({
      menu: id === '' ? menuBack : [menuBack.find((item) => item.id === id)],
    });
  }

  /**
   * 检测需要配置菜单权限的系统
   * @param path
   * @returns {boolean}
   */
  checkNeedPowerPath(path) {
    const needMenuListUrl = ['goods-sys.ruigushop'];
    return needMenuListUrl.some((item) => path.includes(item));
  }

  /**
   * 模块点击
   * @param id 模块id-一般为tab索引用的id 和 菜单id(无systemId时一致)
   * @param path 模块路径
   * @param title 模块名称
   * @param backPath 路径备份
   * @param 是否系统内部打开页面 路径备份
   * @param systemId 模块id - 一般为菜单id
   */
  onClickModule(options) {
    let {
      id,
      path,
      menuUrl,
      icon,
      title,
      backPath,
      systemId = '',
      type,
      children = [],
    } = options;
    if (path === undefined || path === null) return;

    // 页面曝光
    qtPagePvFun(path);

    // 回溯寻找顶部和左侧菜单
    let stateInfo = {};
    if (menuUrl) {
      stateInfo = this.queryMenuKeyByUrl(menuUrl, options);
    } else if (id && id != -1) {
      stateInfo = this.queryMenuKeyById(String(id));
    } else {
      return message.warning('缺少应用id或菜单url');
      //   stateInfo = this.queryMenuKeyByUrl(path, {});
    }

    // 判断当前id 是否是已打开的标签内
    let currentMenuIndex = -1;
    let currentMenu = this.state.openModule.find((item, index) => {
      // menuUrl && !id 表示关联并跳转菜单栏
      // menuUrl && id 表示关联并跳转子应用内页面，不在菜单栏内
      // !menuUrl && id 表示菜单栏点击跳转子应用
      // !menuUrl && !id 错误配置信息
      const someItem =
        menuUrl && !id
          ? String(stateInfo.openModuleId) === String(item.id)
          : String(id) === String(item.id);
      if (someItem) {
        currentMenuIndex = index;
      }
      return someItem;
    });

    // 对于异常跳转参数，补充id和标签名称
    id =
      id && id != -1
        ? String(id)
        : String(stateInfo.openModuleId) ||
          `Math.random-${String(Math.random() * 1e18)}`;
    title = title || (menuUrl ? stateInfo.title : '新标签');

    // 页面没有被打开，模块信息存储至state
    if (!currentMenu) {
      // 聚合菜单记录children信息
      const isMenuLayout = type === 1 ? { type, children } : {};
      currentMenu = {
        id: String(id),
        path: returnPath(path, String(systemId || id || '')),
        icon,
        title,
        // pathFirstRouter 自动打开的模块没有 backPath，兜底为原始 path
        backPath: backPath || path,
        systemId,
        ...isMenuLayout,
        isTenant: true,
        menuUrl: menuUrl || '',
      };
      const openModule = [...this.state.openModule, currentMenu];

      this.setState({
        openModule,
        openModuleId: String(id),
        opera: 'open',
      });

      this.storeSetOpenModule(openModule);
    } else if (id && id != -1) {
      // 判断目标url是否和缓存地址一致，不一致将强制更新加载
      // 标签数据源中的 path 已拼接 id，切换标签、关闭标签时直接复用，
      // 避免重复拼接 id 导致比对不一致而误刷新 iframe
      const linkId = String(systemId || id || '');
      const newPath =
        path.includes('access_token=') || hasIdParam(path, linkId)
          ? path
          : returnPath(path, linkId);
      if (
        currentMenu.path &&
        returnBaseUrl(currentMenu.path) !== returnBaseUrl(newPath)
      ) {
        const arr = [...this.state.openModule];
        arr[currentMenuIndex] = {
          ...currentMenu,
          path: newPath,
        };
        this.setState({
          openModule: arr,
        });
        this.storeSetOpenModule(arr);
        // 获取节点刷新对应iframe的url地址
        setTimeout(() => {
          const currentMenuIframe =
            document.getElementsByClassName('ant-tabs-tab')[currentMenuIndex];
          if (currentMenuIframe) {
            const currentMenuIframeReset =
              currentMenuIframe.getElementsByClassName('customLabel-reset')[0];
            if (currentMenuIframeReset && currentMenuIframeReset.click) {
              currentMenuIframeReset.click();
            }
          }
        }, 100);
      }
      setTimeout(() => {
        this.setState({
          openModuleId: String(id),
          opera: 'change',
        });
      }, 100);
    }
    // 储存当前模块信息
    store.set('openModuleOpenInfo', {
      ...currentMenu,
      id: String(id),
      navIndex: getParam('navIndex') || '0',
      openModuleId: String(id),
      menuUrl: menuUrl || '',
    });
  }

  // 根据id查询keys
  queryMenuKeyByUrl(path, options) {
    const { tenantMenuList } = this.state;
    for (const index in tenantMenuList) {
      const element = tenantMenuList[index];
      const elementInfo = getMenuInfoByUrl(element.treeList, [], path);
      if (elementInfo) {
        setParam('navIndex', String(index));
        this.setState({
          activeIndex: String(index),
          // openModuleId: String(elementInfo.id),
          openKeys: elementInfo.openKeys,
          selectedKeys: [elementInfo.openKeys[0]],
          routerMenu: element.treeList || [],
        });
        return {
          isTenant: true,
          menuUrl: options.menuUrl || '',
          title: options.title || elementInfo.title,
          navIndex: String(index),
          openModuleId: String(elementInfo.id),
          path: options.path,
          systemId: options.systemId || '',
          openKeys: elementInfo.openKeys,
          selectedKeys: [elementInfo.openKeys[0]],
        };
      }
    }
    return {};
  }

  // 根据id查询keys
  queryMenuKeyById(id) {
    const { tenantMenuList } = this.state;
    let stateInfo = {};
    for (const index in tenantMenuList) {
      const element = tenantMenuList[index];
      const info = getMenuInfoById(element.treeList, [], String(id));
      if (info) {
        const { openKeys } = info;
        setParam('navIndex', String(index));
        stateInfo = {
          activeIndex: String(index),
          openModuleId: String(openKeys[0]),
          openKeys,
          selectedKeys: [openKeys[0]],
          routerMenu: element.treeList,
        };
        this.setState(
          (stateInfo = {
            activeIndex: String(index),
            // openModuleId: String(openKeys[0]),
            openKeys,
            selectedKeys: [openKeys[0]],
            routerMenu: element.treeList,
          }),
        );
        return stateInfo;
      }
    }
    return stateInfo;
  }

  /**
   * 关闭模块
   * @param removeModuleId 模块id
   * @param index 已打开模块索引
   */
  removeModule(removeModuleId, index) {
    const openModule = [...this.state.openModule]; // 已打开模块
    let openModuleId = -1;
    openModule.splice(index, 1); // 删除被关闭的模块

    // 设置模块ID
    if (openModule.length !== 0) {
      openModuleId = openModule[openModule.length - 1].id;
      const lastOpenModuleInfo = openModule[openModule.length - 1];
      openModuleId = lastOpenModuleInfo.id;
      // 统一处理打开页面并且上报
      this.onClickModule(lastOpenModuleInfo);
    }

    this.setState({
      openModule,
      openModuleId,
      removeModuleId,
      opera: 'remove',
    });
    this.storeSetOpenModule(openModule);
  }

  removeModuleListByIndex(removeList) {
    const openModule = [...this.state.openModule]; // 已打开模块
    let openModuleId = -1;
    const endList = openModule.filter(
      (item, index) => !removeList.includes(index),
    );

    // 设置模块ID
    if (openModule.length !== 0) {
      openModuleId = openModule[openModule.length - 1].id;
      const lastOpenModuleInfo = openModule[openModule.length - 1];
      openModuleId = lastOpenModuleInfo.id;
      // 统一处理打开页面并且上报
      // this.onClickModule(lastOpenModuleInfo);
    }

    this.setState({
      openModule: endList,
      // openModuleId,
      // removeModuleId,
      opera: 'remove',
    });
    this.storeSetOpenModule(endList);
  }

  /**
   * 更新导航高亮模块
   */
  updateOpenModuleId(openModuleId) {
    const { openModule } = this.state;
    const openModuleInfo = openModule.find(
      (item) => String(item.id) == String(openModuleId),
    );
    this.setState({
      openModuleId,
      opera: 'change',
    });
    // 统一处理打开页面并且上报
    this.onClickModule(openModuleInfo);
  }

  /**
   * 重置导航高亮模块
   */
  resetRemoveModuleId() {
    this.setState({
      removeModuleId: -1,
      opera: 'remove',
    });
  }

  /**
   * 本地存储打开的url
   * @param openModule 已经打开的模块
   */
  storeSetOpenModule(openModule) {
    store.set('openModule', openModule);
  }

  // 读取缓存，加载租户logo和名称、标签模块
  readCacheInfo() {
    const userInfo =
      store.get('userInfo') || window.localStorage.getItem('userInfo') || {};
    const openModule = store.get('openModule') || [];
    this.setState({
      companyLogo: userInfo.logo,
      companyName: userInfo.bizOrgText,
      openModule,
    });
  }

  // 切换菜单
  onClickActive(navIndex) {
    const { tenantMenuList } = this.state;
    if (tenantMenuList.length === 0) return;
    let activeIndex = navIndex;
    if (!tenantMenuList[navIndex]) {
      activeIndex = 0;
    }
    const { scope, scopeName, treeList } = tenantMenuList[activeIndex];
    // const children = treeList.filter(
    //   (item) => getArray(item.children).length > 0,
    // );
    this.setState({
      activeIndex,
      isInitStatus: true,
    });
    setParam('navIndex', activeIndex);
    this.handleNavMenu(treeList);
  }

  handleClick(params) {
    this.setState({
      isInitStatus: false,
    });
  }

  toggleCollapsed() {
    this.setState({
      collapsed: !this.state.collapsed,
    });
  }

  render() {
    const {
      selectedKeys,
      openKeys,
      routerMenu,
      collapsed,
      tenantMenuList,
      activeIndex,
    } = this.state;
    return (
      <div className="home">
        {/*header*/}
        {this.state.companyName ? (
          <IndexHead
            isTenant={true}
            companyLogo={this.state.companyLogo}
            companyName={this.state.companyName}
            headerMenu={this.state.headerMenu}
            activeIndex={this.state.activeIndex}
            onClickActive={(e) => this.onClickActive(e)}
            onClickModule={(e) => this.onClickModule(e)}
          />
        ) : (
          ''
        )}

        {/*system content*/}
        <Layout className="menuLayout">
          <Sider width={220} collapsed={collapsed}>
            {/* 标题和展开菜单开关 */}
            <div className="flex-row-center-center menu-title">
              <div
                className={`menuLayout-title flex-row-start-center ${
                  this.state.collapsed ? 'menuLayout-title-w-0' : ''
                }`}
              >
                {tenantMenuList[activeIndex]?.scopeName || ''}
              </div>
              <span className="">
                <i
                  className={`iconfont icon-Expand_${
                    collapsed ? 'left' : 'right'
                  }`}
                  onClick={() => this.toggleCollapsed()}
                />
              </span>
              <div className="menuLayout-title-hr"></div>
            </div>

            {/* 菜单树 */}
            <Menu
              mode="inline"
              selectedKeys={selectedKeys}
              openKeys={openKeys}
              className={'menuLayout-menu-home'}
              expandIcon={(e) => (
                <span>
                  <i
                    className={`iconfont iconfont-expandIcon ${
                      e.isOpen ? 'icon-Arrow_Up' : 'icon-Arrow_Down'
                    }`}
                  />
                </span>
              )}
              items={routerMenu}
              inlineCollapsed={collapsed}
              onClick={this.onMenuClick}
              onOpenChange={this.onMenuOpen}
            />
          </Sider>
          <Layout>
            {this.state.openModule.length > 0 ? (
              <IndexTabsNavigation
                isTenant={true}
                openModule={this.state.openModule}
                openModuleId={this.state.openModuleId}
                updateOpenModuleId={this.updateOpenModuleId.bind(this)}
                removeModule={this.removeModule.bind(this)}
                removeModuleListByIndex={this.removeModuleListByIndex.bind(
                  this,
                )}
              />
            ) : (
              ''
            )}
            <Content
              className="site-layout-background"
              style={{
                margin: 0,
              }}
            >
              {this.state.openModule.length > 0 ? (
                <IndexIframe
                  isTenant={true}
                  openModule={this.state.openModule}
                  openModuleId={this.state.openModuleId}
                  opera={this.state.opera}
                  removeModuleId={this.state.removeModuleId}
                  resetRemoveModuleId={this.resetRemoveModuleId.bind(this)}
                />
              ) : (
                ''
              )}
            </Content>
          </Layout>
        </Layout>

        {/* {this.state.activeIndex === 0 && this.state.isInitStatus ? (
          <div className="index-content">
            <div className="title">常用功能</div>
            <div className="content flex-row-start-center index-content-list">
              {this.state.homeList.map((item, index) => {
                const imgUrl =
                typeof item.icon === "string"
                  ? item.icon.includes("http") ||
                  item.icon.includes("https")
                    ? item.icon
                    : placeholderImg
                  : placeholderImg;
                return (
                  <div
                    key={index}
                    className="index-content-item flex-col-center-center"
                    onClick={() => this.handleClick(item)}
                  >
                    <img
                      src={imgUrl}
                      alt="placeholder"
                      className="display-block system-module-img"
                    />
                    <span className="display-block system-module-name fs-14 text-center text-ellipsis">
                      {item.title}
                    </span>
                  </div>
                );
              })}
            </div>
          </div>
        ) : (
          <></>
        )} */}
      </div>
    );
  }
}

export default withRouter(Index);
